import React, { Fragment } from "react";
import { Controlled as CodeMirror } from "react-codemirror2";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

import { BTN } from "../../core/constants";

import CloseBar from "./dialogCloseBar";

export function EditConfig(props) {
  const { isOpen, onClose, nluConfigText, mode, title } = props;

  const doCancel = () => {
    onClose(BTN.APPLY, { nluConfigText: nluConfigText });
  };

  return (
    <Fragment>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={isOpen}
        aria-labelledby="edit-config-dialog-title"
      >
        <CloseBar onClose={doCancel} title={title}/>
        <DialogContent style={{ overflow: "hidden", padding: 0 }}>
          <CodeMirror
            value={nluConfigText}
            options={{
              mode,
              lineNumbers: true,
            }}
            readOnly
          />
        </DialogContent>
      </Dialog>
    </Fragment>
  );
}
